import { action, makeObservable, observable, runInAction } from "mobx";
import * as DoctorsService from '../services/DoctorsService';
import * as AppointmentTypesService from '../services/AppointmentTypesService';
import { ClinicIds, clinicStore } from "../store/ClinicStore";
import { doctorsStore } from "../store/DoctorsStore";
import { AppointmentType } from "../types/appointmenttype";
import { ShowAlertOptions } from "../components/AlertProvider";
import { appointmentTypesStore } from "../store/AppointmentTypesStore";



class SessionManager {
    showAlert: ((options: ShowAlertOptions) => void) | undefined = undefined;

    @observable isLoadingDoctors = false;
    @observable isLoadingAppointments = false;
    @observable isLoadingDoctorsAvailable = false;
    @observable patientId = '';
    @observable isNewPt = true;

    constructor() {
        makeObservable(this);
    }

    setShowAlert = (showAlert: (options: ShowAlertOptions) => void) => {
        this.showAlert = showAlert;
    }

    @action
    init = async (clinicIds: ClinicIds) => {
        clinicStore.setCurrentClinicIds(clinicIds);
        await this.loadServiceTypesWithAptTypes(); // Ensure async function completes
    }

    @action
    loadServiceTypesWithAptTypes = async () => {
        try {
            runInAction(() => { this.isLoadingAppointments = true; }); // ✅ Use runInAction
            const serviceTypesWithAptTypes = await AppointmentTypesService.getAllServiceTypesWithAppointmentTypes(clinicStore.selectedClinicIds);
            runInAction(() => {
                appointmentTypesStore.setServiceTypesWithAppointmentTypes(serviceTypesWithAptTypes);
                if (!appointmentTypesStore.selectedAptType) {
                    appointmentTypesStore.selectedAptType = AppointmentTypesService.getDefaultAppointmentType(serviceTypesWithAptTypes);
                }
            });
        } catch (error) {
            console.error(error);
            this.showAlert?.({
                severity: "error",
                title: "Whoops!",
                message: "There was an issue loading the appointment types for this page",
            });
        } finally {
            runInAction(() => { this.isLoadingAppointments = false; }); 
        }
    }

    @action
    updateDoctorsForAppointmentType = async (appointmentType: AppointmentType) => {
        try {
            runInAction(() => { this.isLoadingDoctors = true; }); 

            const docsForAptData = await DoctorsService.getDoctorsForAptType(
                clinicStore.selectedClinicIds,
                appointmentType.appointment_type_id
            );

            runInAction(() => {
                doctorsStore.setSelectedAptTypeDoctors(docsForAptData?.doctors);
                doctorsStore.setSelectedAptTypeFirstAvailableTimes(docsForAptData?.first_time_slots);
            });
        } catch (error) {
            console.error(error);
            // this.showAlert?.({
            //     severity: "error",
            //     title: "Whoops!",
            //     message: "There was an issue loading the doctors for this appointment type",
            // });
        } finally {
            runInAction(() => { this.isLoadingDoctors = false; }); 
        }
    }

    @action
    setPatientId = (patientId: string) => {
        this.patientId = patientId;
    }

    @action
    setIsNewPatient = (isNewPatient: boolean) => {
        this.isNewPt = isNewPatient;
    }
}

export const sessionManager = new SessionManager();
